import { faArrowDown, faArrowUp, faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Col, Placeholder, Row } from "react-bootstrap";
import { RiskFeatureModal } from "./RiskFeatureModal";
import { useMemo, useState } from "react";
import { PatientVisit } from "../../../amplify/appsync/search-patients";

export interface RiskConfig {
    title: string,
    model: string,
    threshold?: number,
}

export const RiskTextSquare = (props: {
    patientVisit: PatientVisit,
    config: RiskConfig,
    riskScores: any,
    riskDetails: any,
    historyMetrics?: any,
    isLoading: boolean,
    onClick?: any,
    adminOnly?: boolean,
}) => {

    const actualThreshold = props.config.threshold === undefined ? 0.5 : props.config.threshold;
    const currentMetric = props.riskScores[props.config.model].prediction;
    const [showModal, setShowModal] = useState<boolean>(false);

    const historyRisks = useMemo(() => {
        const historyRisks: any[] = [];
        if (props.config.model === "Admit_dispo") {
            if (props.riskScores["Admit_rooming"]) {
                historyRisks.push({
                    ...props.riskScores["Admit_rooming"],
                    "title": "Admit Risk at Rooming",
                });
            }
        }
        if (props.config.model === "Admit_dispo" || props.config.model === "Admit_rooming") {
            if (props.riskScores["Admit_triage"]) {
                historyRisks.push({
                    ...props.riskScores["Admit_triage"],
                    "title": "Admit Risk at Rooming",
                });
            }
        }
        return historyRisks;
    }, [props.riskScores, props.config])

    const handleClick = () => {
        if (props.onClick) {
            props.onClick();
        } else {
            setShowModal(true);
        }
    };

    return (
        <>
            <Card onClick={handleClick} className="metrics-risk-card w-100 h-100" 
                // bg={currentMetric >= actualThreshold ? 'danger' : ''} 
                // text={currentMetric >= actualThreshold ? 'white' : ''}
            >
                <Card.Body>
                    <Row>
                        <Col className="metrics-title">{props.config.title}</Col>
                    </Row>
                    <Row>
                        {
                            props.isLoading ? (
                                <Placeholder as={Card.Text} animation="glow">
                                    <Placeholder xs={7} /> <Placeholder xs={4} />{' '}
                                    <Placeholder xs={6} />
                                </Placeholder>
                            ) : (
                                <>
                                    <Col xs="auto" className="metrics-value">{Math.round(currentMetric * 100) / 100}</Col>
                                    <Col className="metrics-relative">
                                        <Row>
                                            <Col className={currentMetric < actualThreshold ? "metrics-good" : "metrics-bad"}>
                                                <FontAwesomeIcon icon={currentMetric >= actualThreshold ? faArrowUp : faArrowDown} />{' '}
                                                {currentMetric >= actualThreshold ? "High" : "Low"}
                                            </Col>
                                        </Row>
                                    </Col>
                                </>
                            )
                        }
                    </Row>
                    {
                        props.adminOnly && (
                            <Row>
                                <Col>
                                    <small><FontAwesomeIcon icon={faLock} /> Admin Only</small>
                                </Col>
                            </Row>
                        )
                    }
                    
                    {
                        props.historyMetrics && props.historyMetrics.map((metric: any) => (
                            <Row>
                                <Col xs="auto" className="metrics-history-value">{metric.value}</Col>
                                <Col>
                                    <Row>
                                        <Col className={`${metric.value < actualThreshold ? "metrics-good" : "metrics-bad"} metrics-history-description`}>
                                            <FontAwesomeIcon icon={metric.value >= actualThreshold ? faArrowUp : faArrowDown} />{' '}
                                            {metric.value >= actualThreshold ? "High" : "Low"} (at {metric.title})
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        ))
                    }
                </Card.Body>
            </Card>
            <RiskFeatureModal showModal={showModal} setShowModal={setShowModal} config={props.config} csn={props.patientVisit.csn} currentMetric={currentMetric} historyRisks={historyRisks} riskDetails={props.riskDetails} />
        </>
    );
}
